export { default as FundsDetailPage } from "./FundsDetailPage";
export { default as FundsDetailPageFactory } from "./FundsDetailPageFactory";
export type { FundsDetailFactoryData } from "./FundsDetailPageType";
